module.exports = __webpack_public_path__ + "static/scale-model-of-historic-downtown-walking-tour-in-lexington-kentucky-8ece4758645cff1257933c31a27da2fc.png";